import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { useVisitor } from '../../context/VisitorContext';
import './game.css';

export default function VisitorProfileGate() {
  const { needsProfile, saveProfile } = useVisitor();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  const handleStart = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await saveProfile(name, email);
    } finally {
      setSaving(false);
    }
  };

  const handleSkip = async () => {
    setSaving(true);
    try {
      await saveProfile('Explorador', '');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={needsProfile}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { background: 'transparent', boxShadow: 'none' } }}
    >
      <form className="visitor-gate" onSubmit={handleStart}>
        <span className="visitor-gate-eyebrow">Museo Digital 3D</span>
        <h2>¡Bienvenido, explorador!</h2>
        <p>
          Creá tu perfil para descubrir esculturas, armar tu colección y avanzar
          de nivel a medida que recorrés el museo.
        </p>

        <label className="visitor-gate-label">
          Tu nombre
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="¿Cómo te llamás?"
            maxLength={40}
            autoFocus
          />
        </label>

        <label className="visitor-gate-label">
          Email (opcional)
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="para guardar tu progreso"
            maxLength={120}
          />
        </label>

        <button type="submit" className="visitor-gate-btn" disabled={saving || !name.trim()}>
          {saving ? 'Creando perfil...' : 'Comenzar a explorar'}
        </button>
        <button type="button" className="visitor-gate-skip" onClick={handleSkip} disabled={saving}>
          Continuar como invitado
        </button>
      </form>
    </Dialog>
  );
}
